
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuDatingHarajukuDateLunchImage } from "@src/constants/images";
import { meta as littleRimaPageMeta } from "./little_rima.mdx";
export const meta = {
  path: "/media/harajuku/dating",
  title: "【デートにぴったり】原宿で雰囲気と味が抜群なランチのお店４選",
  description: "原宿でデートをしたいけど、おしゃれなお店が見つからない。おしゃれなお店はあっても、せっかくなら名店の味を食べたい。この二つをどちらも満たしているお店を厳選してご紹介します。中にはミシュランに選ばれた実績があるお店などもご紹介。ぜひ、雰囲気と味の二つを楽しめるランチデートを原宿でお過ごしください。",
  topImg: harajukuDatingHarajukuDateLunchImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "人気店", "まとめ記事", "メニュー詳細", "デート"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿でデートをしたいけど、おしゃれなお店が見つからない。おしゃれなお店はあっても、せっかくなら名店の味を食べたい。`}</p>
    <p>{`そういった悩みを抱えた方はいませんでしょうか？この二つをどちらも満たしているお店を厳選してご紹介します。`}</p>
    <p>{`テラス席も完備してい流おしゃれなお店、雰囲気抜群でニオイがつきづらい焼肉店、またミシュランに選ばれた実績があるお店、ディナーだと単価が２万円の鉄板焼きといった雰囲気と味の二つを楽しめるランチデートを原宿でお過ごしください。`}</p>
    <h2>{`ピッツェリア カンテラ`}</h2>
    <InstaImage postId="CAjayRwgZvd" mdxType="InstaImage" />
    <p>{`原宿駅から徒歩 7 分、明治神宮駅から徒歩 2 分の好アクセスの立地にあるのが、原宿のピザで有名なピッツェリア カンテラ。
3 年連続百名店に選出されるピザ業界でも屈指の名店で、食べログの評価は 3.7 を超える好評価。`}</p>
    <h3>{`スタイリッシュな店`}</h3>
    <InstaImage postId="B-OtdENg96g" mdxType="InstaImage" />
    <InstaImage postId="B_Ty33uAgGC" mdxType="InstaImage" />
    <p>{`原宿の雰囲気とは少し違ったスタイリッシュな内装で、デートにはぴったりの雰囲気です。テラス席を完備しているので、晴れた日にはテラス席で食べていただくと、普段とは違ったランチの雰囲気が楽しめると思います。`}</p>
    <h3>{`ランチメニュー`}</h3>
    <InstaImage postId="B6ws-aUAh6Z" mdxType="InstaImage" />
    <InstaImage postId="B_7US6xAouz" mdxType="InstaImage" />
    <p>{`ピザかパスタセットがデートだとおすすめ！産地の味を使った料理をシェアして食べていただくと、お店の味をふんだんに楽しめるではないかと思います。`}</p>
    <ShopInfoBox shopId="brjat6223akg00cd2nu0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【焼肉】原宿焼肉 KINTAN`}</h2>
    <InstaImage postId="B5hWWuCFIzO" mdxType="InstaImage" />
    <InstaImage postId="BvZdHo8B_am" mdxType="InstaImage" />
    <p>{`全国的に焼肉の名店として知られる人気店「KINTAN」の原宿店です。
グレーを基調としたおしゃれで落ち着いた店内はデートにぴったりの雰囲気。`}</p>
    <p>{`食べログの評価は 3.5 を超える人気で、ランチディナー問わずたくさんのお客様が来店されています。`}</p>
    <h3>{`ニオイがつかない工夫`}</h3>
    <p>{`「せっかくのデートの日にニオイが付いたら台無し」という方でも安心してランチに行くことができます。
ロースターや設備にこだわった作りをしているので、焼肉を焼いても煙のニオイがつきにくくなっているそう。
お肉を食べても煙がつかないは、焼肉ランチに行きたい方には嬉しいですよね。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="B6LcSKLAMgd" mdxType="InstaImage" />
    <InstaImage postId="B2fWyHenkDA" mdxType="InstaImage" />
    <p>{`焼肉ランチのセットは、肉の種類やボリュームによって数種類あるのですが、サイドメニューのごはん、スープ、サラダのお替りができます。また、ごはんが白米か五穀米が選べるのも健康を意識している方にとっては嬉しいですよね。
デートで美味しい焼肉を心いくまで楽しんでください！`}</p>
    <ShopInfoBox shopId="brruvmq23akg00835qag" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【蕎麦】玉笑`}</h2>
    <InstaImage postId="B8d0T2fAlbw" mdxType="InstaImage" />
    <p>{`原宿から徒歩 5 分ほどの距離に、蕎麦の名店「玉笑があります」
世界的な格付け機関のミシュランにも数年連続で取り上げられた実績や、食べログの評価も 4.0 に迫るほど。
そんな玉笑では、普段とは違ったランチデートが楽しめます。`}</p>
    <h3>{`入口から内装まで落ち着いた空間`}</h3>
    <InstaImage postId="CBqGpQxjYO5" mdxType="InstaImage" />
    <p>{`コンクリートで作られた外観は大人な雰囲気を漂わせており、麻でできたのれんには小さく「玉笑」という文字が趣のある空間を作り出しています。`}</p>
    <InstaImage postId="CBsgpKaJ4m_" mdxType="InstaImage" />
    <p>{`内装は木を基調とした温かみのある空間で、デートにはぴったりの雰囲気抜群のお店。`}</p>
    <h3>{`せいろ蕎麦が人気`}</h3>
    <InstaImage postId="B9trQt7gAQg" mdxType="InstaImage" />
    <p>{`コシのある蕎麦を、卵を入れたつゆにつけて食べるのが玉笑のせいろ蕎麦。つゆだけではなく、卵の風味がそばを包み込み、ここだけでしか味わえない味になります。
デートにはぴったりのお店なので、ぜひチャレンジしてみてください！`}</p>
    <ShopInfoBox shopId="brh1uvq23akg00da7npg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【ハンバーグ】リトルリマ`}</h2>
    <InstaImage postId="BePbqwcHj0c" mdxType="InstaImage" />
    <InstaImage postId="BntlJjYHLp2" mdxType="InstaImage" />
    <p>{`原宿から青山方面に向かった先に位置するハンバーグの名店「リトルリマ」。
100％の神戸牛が食べられることで有名なリトルリマは、知る人ぞ知る隠れ家的な名店で、鉄板焼きのランチが食べられるデートにぴったりな雰囲気抜群のお店です。`}</p>
    <h3>{`名物ハンバーグランチ`}</h3>
    <InstaImage postId="BcOi73an6Lt" mdxType="InstaImage" />
    <p>{`ディナータイムで訪れると、リトルリマでは客単価が 2 万円を超えるお店。
ランチタイムだと、単価千円〜二千円のお値段で、神戸牛 100%のお肉を使ったハンバーグランチが食べられるので、デートでもで高級なお店だと手が出しづらいという方も、気軽にランチができるのがポイント！
注文を受けてからその場で調理をしてくれて、グラム数は、150、170、200g の中から選ぶことができます！`}</p>
    <LinkWithThumbnail meta={littleRimaPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brntfvi23akg00f31td0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿でデートにぴったりなお店をご紹介させていただきましたが、いかがでしたか？
原宿とは思えないほど雰囲気が抜群なお店や、そのお店だけでしか食べられないランチなど、デートを選ぶ際には参考になる情報なのではないかと思っております。
お好みのお店を見つけて、ぜひ素敵なランたいタイムをお過ごしください。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;